// 存放一些公用dispatchs
import { PayInfo } from '../../model/store/modules/ticket';
import store from '../../model/store/index';
// import { ApiData } from '../../model/store/modules/originData'

// export const dispatchActionSetServeData =
// (apiData:ApiData) => store.dispatch('originData/actionSetServeData', apiData)
export const dispatchPayInfo = (payInfo: PayInfo) => store.dispatch('ticket/actionSetPayInfo', payInfo);

export default {
  // dispatchActionSetServeData,
};
